import React, { Component } from 'react';
import './Schedules.css';
import { Redirect } from 'react-router-dom';
import ReactTable from 'react-table';
import { t } from 'i18next';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { FaTrashO as Trash, FaEdit as Edit, FaQuestionCircleO as Help } from 'react-icons/lib/fa';
import TitleBar from '../../../titleBar/TitleBar';
import Modal from '../../subComponents/modals/Modal';
import MakeSchedule from '../../subComponents/makeSchedule/MakeSchedule';
import NavBar from '../../subComponents/navBar/navBar';
import 'react-table/react-table.css';
import 'react-datepicker/dist/react-datepicker.css';
import CRUDTable from '../../subComponents/CRUDTable/CRUDTableComponent';
import SplashScreen from '../../subComponents/splashscreen/splashscreen';
import {
  retrieveModels, retrieveSchedules, completedSchedules, deleteSchedule, setSession,
} from '../../services/testResultsService';
import { ANALYTICS_WRITE_ROLES } from '../../../../constants';
// import { showError } from '../../../../reducer/actions';

const getTimeZone = () => {
  const currentZone = moment.tz.guess();
  return {
    zone: moment.tz(currentZone).format('z'),
  };
};
class Schedules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      completedSchedules: [],
      createModalShow: false,
      deleteModalShow: false,
      filteredModels: {
      },
      getStartedModalShow: false,
      individualRun: {
        hello: 'hello',
      },
      inProgressModalShow: false,
      // models: [],
      scheduleDeleted: false,
      scheduleInfo: {
      },
      scheduleToDelete: '',
      scheduleToUpdate: '',
      showResults: false,
      toggleTables: 'Completed Runs',
      updateJob: false,
      updateModalShow: false,
    };
    this.deleteScheduleRequest = this.deleteScheduleRequest.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openCreateModal = this.openCreateModal.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.toggleTables = this.toggleTables.bind(this);
    this.userZone = getTimeZone();
  }

  componentDidMount() {
    this.setOEM();
    if (! localStorage.DontShow) {
      this.setState({
        getStartedModalShow: true,
      });
    }
    this.completedBtn.focus();
    retrieveSchedules().then((requestData) => {
      this.setActiveSchedules(requestData);
    });
    retrieveModels().then((requestData) => {
      this.setModels(requestData);
      this.groupByModelName(requestData, 'trainModelName');
    });
    completedSchedules().then((requestData) => {
      this.setCompletedSchedules(requestData);
    });
  }

  setOEM = () => {
    const { session } = this.props;
    setSession(session);
  }

  setActiveSchedules(data) {
    const activeSchedules = [];
    data.body.forEach((job) => {
      const formatTime = job.StartTime.replace(/:/g, '');
      const startTime = moment(formatTime).format();
      const localTimeJob = {
        ...job
      };
      localTimeJob.StartTime = startTime;
      if (job.JobStatus !== 'Completed') {
        activeSchedules.push(localTimeJob);
      }
    });
    this.setState({
      activeSchedules,
    });
  }


  setCompletedSchedules(data) {
    this.setState({
      completedSchedules: data.body,
    });
  }

  setModels(data) {
    this.setState({
      // not sure why this says models isn't used in state, it is
      // eslint-disable-next-line react/no-unused-state
      models: data.body,
    });
  }

  reloadSchedules = () => {
    retrieveSchedules().then((requestData) => {
      this.setActiveSchedules(requestData);
    });
  }

  showHelp = () => {
    this.setState({
      getStartedModalShow: true
    });
  }

  showHelp = () => {
    this.setState({
      getStartedModalShow: true
    });
  }

  /* Here we are sorting all of the models by trainModel name,
    so each version can exist in the same array as the other versions of that model */
  groupByModelName(data, property) {
    const models = data.body;
    const newMods = models.reduce((memo, x) => {
      // eslint-disable-next-line no-param-reassign
      if (! memo[x[property]]) { memo[x[property]] = []; }
      memo[x[property]].push(x);
      return memo;
    }, {
    });
    this.setState({
      filteredModels: newMods,
    });
  }

  toggleTables(e) {
    // const { dispatch } = this.props;
    // console.log(this.props);
    // console.log(e.target.innerHTML);
    // dispatch(showError({status: '', statusText: `${e.target.innerHTML} error`}))
    this.setState({
      toggleTables: e.target.innerHTML,
    });
  }

  deleteScheduleRequest() {
    const { scheduleToDelete: JobName } = this.state;
    // const JobName = this.state.scheduleToDelete;
    deleteSchedule(JobName).then(() => {
      this.setState({
        scheduleDeleted: true,
      });
      setTimeout(() => { this.openDeleteModal(JobName); }, 2000);
      setTimeout(() => {
        this.setState({
          scheduleDeleted: false,
        });
      }, 2100);
      retrieveSchedules();
    });
  }

  closeModal() {
    this.setState({
      createModalShow: false,
      deleteModalShow: false,
      getStartedModalShow: false,
      inProgressModalShow: false,
      updateJob: false,
      updateModalShow: false,
    });
  }

  openCreateModal() {
    this.setState({
      createModalShow: true,
      updateJob: false,
    });
  }

  openDeleteModal(jobInfo) {
    const { scheduleDeleted, deleteModalShow } = this.state;
    if (jobInfo.JobStatus === 'In_Process') {
      this.setState({
        inProgressModalShow: true,
      });
      return;
    }
    if (scheduleDeleted) {
      setTimeout(this.setState({
        deleteModalShow: false,
        scheduleDeleted: true,
      }), 2000);
    } else {
      this.setState({
        deleteModalShow: ! deleteModalShow,
        scheduleToDelete: jobInfo.JobName,
      });
    }
  }

  openUpdateModal(scheduleInfo) {
    if (scheduleInfo.JobStatus === 'In_Process') {
      this.setState({
        inProgressModalShow: true,
      });
      return;
    }
    const { updateModalShow } = this.state;
    this.setState({
      scheduleInfo,
      scheduleToUpdate: scheduleInfo.JobName,
      updateJob: true,
      updateModalShow: ! updateModalShow,
    });
  }

  openResultsModal(resultsInfo) {
    this.setState({
      individualRun: resultsInfo,
      showResults: true,
    });
  }

  render() {
    const completedRunsColumns = [
      {
        accessor: 'JobName',
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.JobName'),
        // Cell: props => (
        //     <Link to={{pathname: "/detectionResults", state: {individualRun: props.original}}}
        //      onClick={() => {()=> {this.setIndividual(props.original) }}}>{props.value}</Link>
        // )
      },
      {
        accessor: 'ModelName',
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.ModelName'),
      },
      {
        accessor: 'ModelPlotType',
        className: 'table-data',
        Header: 'Algorithm',
        minWidth: 140,
      },
      {
        accessor: 'VersionID',
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.VersionID'),
        minWidth: 70,
      },
      {
        accessor: 'Frequency',
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.Frequency'),
      },
      {
        accessor: 'RunDate',
        Cell: (row) => {
          const date = moment(row.value, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]');
          return (
            <div style={{
              textAlign: 'center',
            }}
            >
              {date.isValid() ? date.format('MM/DD/YY') : 'N/A'}
            </div>
          );
        },
        Header: t('tensorAnalytics.tableHeaders.RunDate'),
      },
      {
        accessor: 'DevicesEvaluatedCount',
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.DevicesEvaluated'),
      },
      {
        Cell: props => (
          <div className="actions-btn-group">
            <button className="results-btn"
              // size={15}
              type="button"
              onClick={() => { this.openResultsModal(props.original); }}
            >
              {t('tensorAnalytics.schedulesPage.viewResults')}
            </button>
          </div>
        ),
        filterable: false,
        Header: 'Results',
        sortable: false,
      },

    ];
    const activeRunsColumns = [
      {
        accessor: 'JobName',
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.JobName'),
        minWidth: 200,
      },
      {
        accessor: 'JobStatus',
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.JobStatus'),
      },
      {
        accessor: 'ModelName',
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.ModelName'),
        minWidth: 200,
      },
      {
        accessor: 'VersionID',
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.VersionID'),
        width: 70,
      },
      {
        accessor: 'Frequency',
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.Frequency'),
      },
      {
        accessor: 'RangeStart',
        Cell: (row) => {
          const date = moment(row.value, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]');
          return (
            <div>
              {date.isValid() ? date.format('MM/DD/YY') : 'N/A'}
            </div>
          );
        },
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.RangeStart'),
      },
      {
        accessor: 'RangeEnd',
        Cell: (row) => {
          const date = moment(row.value, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]');
          return (
            <div>
              {date.isValid() ? date.format('MM/DD/YY') : 'N/A'}
            </div>
          );
        },
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.RangeEnd'),
      },
      {
        accessor: 'ScheduleDate',
        Cell: (row) => {
          const date = moment(row.value, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]');
          return (
            <div>
              {date.isValid() ? date.format('MM/DD/YY') : 'N/A'}
            </div>
          );
        },
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.ScheduleDate'),
        minWidth: 115,
      },
      {
        accessor: 'StartDay',
        Cell: (row) => {
          const date = moment(row.value, 'dddd');
          return (
            <div>
              {date.isValid() ? date.format('dddd') : 'N/A'}
            </div>
          );
        },
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.StartDay'),
      },
      {
        accessor: 'StartDayMonth',
        Cell: (row) => {
          const date = moment(row.value, 'DD');
          return (
            <div>
              {date.isValid() ? date.format('DD') : 'N/A'}
            </div>
          );
        },
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.StartDayMonth'),
      },
      {
        accessor: 'StartTime',
        Cell: (row) => {
          const date = moment(row.value, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]');
          return (
            <div>
              {date.isValid() ? `${date.format('h:mm:ss a')} ${this.userZone.zone.toLocaleLowerCase()}` : 'N/A'}
            </div>
          );
        },
        className: 'table-data',
        Header: t('tensorAnalytics.tableHeaders.StartTime'),
      },
    ];
    const {
      activeSchedules, completedSchedules: completedSchedulesList, toggleTables, showResults,
      scheduleDeleted, scheduleInfo, scheduleToUpdate, filteredModels, updateJob, getStartedModalShow,
      deleteModalShow, createModalShow, updateModalShow, inProgressModalShow, individualRun,
    } = this.state;

    const deleteChildren = (
      <div>
        <h4 className={scheduleDeleted ? 'hide' : 'show'}>
          {t('tensorAnalytics.schedulesPage.scheduleDeleteConfirm')}
        </h4>
        <h4 className={scheduleDeleted ? 'show' : 'hide'}>
          {t('tensorAnalytics.schedulesPage.scheduleDeleteNotification')}
        </h4>
        <div className="modal-button-group">
          <button className="modal-cancel-button"
            type="button"
            onClick={this.closeModal}
          >
            {t('tensorAnalytics.common.cancel')}
          </button>
          <button className={scheduleDeleted ? 'hide' : 'modal-delete-button'}
            type="button"
            onClick={this.deleteScheduleRequest}
          >
            {t('tensorAnalytics.common.delete')}
          </button>
        </div>
      </div>
    );

    let updateJobModal;
    let updateSchedule;
    let createSchedule;
    let createJobModal;
    let createScheduleBtn;
    let inProgressWarning;
    let splashModal;
    let successfulSchedules;

    if (completedSchedulesList && activeSchedules) {
      const failedSchedules = activeSchedules.filter(job => job.JobStatus === 'Failed');
      const failedScheduleNames = failedSchedules.map(schedule => schedule.JobName);
      successfulSchedules = completedSchedulesList.filter((job) => ! failedScheduleNames.includes(job.JobName));
    }
    if (showResults) {
      return (
        <Redirect to={{
          pathname: '/detectionResultsDev',
          state: {
            results: individualRun,
          },
        }}
        />
      );
    }
    if (getStartedModalShow) {
      const splashScreen = (
        <SplashScreen closeModal={this.closeModal} />
      );
      splashModal = (
        <Modal close={this.closeModal}
          title={t('tensorAnalytics.schedulesPage.newToThisApplication')}
          style={{
            width: '95%',
          }}
        >
          {splashScreen}
        </Modal>
      );
    }
    // write access check
    const { session } = this.props;
    if (ANALYTICS_WRITE_ROLES.includes(session.role)) {
      createScheduleBtn = (
        <button onClick={(e) => { this.openCreateModal(e); }}
          className="create-schedule-btn"
          type="button"
        >
          {t('tensorAnalytics.schedulesPage.createSchedule')}
        </button>
      );
      // adding write actions to active runs column
      activeRunsColumns.push(
        {
          Cell: props => (
            <div className="actions-btn-group">
              <Edit size={20}
                onClick={() => { this.openUpdateModal(props.original); }}
              />
              <Trash size={20}
                onClick={() => { this.openDeleteModal(props.original); }}
              />
            </div>
          ),
          className: 'table-data',
          filterable: false,
          Header: t('tensorAnalytics.CRUDTableComponent.actionTableHeader'),
          sortable: false,
        },
      );
      // moved these conditionals inside write access check so they're not assessed if user is not admin
      if (updateJob) {
        updateSchedule = (
          <MakeSchedule retrieveSchedules={this.retrieveSchedules}
            scheduleInfo={scheduleInfo}
            closeModal={this.closeModal}
            updateJob={updateJob}
            scheduleToUpdate={scheduleToUpdate}
            filteredModels={filteredModels}
            session={session}
          />
        );
        updateJobModal = (
          <Modal close={this.closeModal}
            title={t('tensorAnalytics.schedulesPage.updateSchedule')}
          >
            {updateSchedule}
          </Modal>
        );
      } else {
        createSchedule = (
          <MakeSchedule retrieveSchedules={this.retrieveSchedules}
            closeModal={this.closeModal}
            filteredModels={filteredModels}
            reloadSchedules={this.reloadSchedules}
            session={session}
          />
        );
        createJobModal = (
          <Modal close={this.closeModal}
            title={t('tensorAnalytics.schedulesPage.createSchedule')}
          >
            {createSchedule}
          </Modal>
        );
      }
      inProgressWarning = (
        <div className="warning-content">
          <h5>{t('tensorAnalytics.schedulesPage.inProgressWarning')}</h5>
        </div>
      );
    }

    return (
      <div className="schedules-page">
        <div>
          <TitleBar title="schedules">
            <Help onClick={this.showHelp}
              size={36}
              // className="help-button"
              style={{
                fill: '#669044',
                padding: '5px 7px',
              }}
            />
            {/* <TimeAggregation value={this.props.presistFilters.aggregate_by} /> */}
          </TitleBar>
          <NavBar />
          <div className="schedules-container">
            {/* <Filter /> */}
            <div className="table">
              <div>
                {createScheduleBtn}
              </div>
              <div className="tables-tabs">
                <button className="completed-runs-btn"
                  onClick={(e) => { this.toggleTables(e); }}
                  type="button"
                  ref={(c) => { this.completedBtn = c; }}
                >
                  {t('tensorAnalytics.schedulesPage.completedRuns')}
                </button>
                <button className="active-schedules-btn"
                  onClick={(e) => { this.toggleTables(e); }}
                  type="button"
                >
                  {t('tensorAnalytics.schedulesPage.activeSchedules')}
                </button>
              </div>

              <div className={toggleTables === 'Active Schedules' ? 'show active-runs-container' : 'hide'}>
                {toggleTables === 'Active Schedules' ? (
                  <ReactTable columns={activeRunsColumns}
                    data={activeSchedules}
                    filterable
                    defaultPageSize={15}
                    noDataText={t('tensorAnalytics.schedulesPage.pleaseWaitText')}
                    sortable
                    resizable={false}
                  />
                ) : (
                  null
                )}
              </div>
              <div className={toggleTables === 'Completed Runs' ? 'show completed-runs-container' : 'hide'}>
                {toggleTables === 'Completed Runs' ? (
                  <CRUDTable columns={completedRunsColumns}
                    data={successfulSchedules || completedSchedulesList}
                    showPagination
                    noDataText={t('tensorAnalytics.schedulesPage.pleaseWaitText')}
                    options={{
                      deleteRowFunctionality: false,
                      exportToCSV: false,
                      selectRowsFunctionality: false,
                    }}
                    defaultSorted={[{
                      desc: true,
                      id: 'RunDate',
                    }]}
                  />
                ) : (
                  null
                )}
              </div>
            </div>

          </div>
        </div>
        <div className={deleteModalShow ? 'show' : 'hide'}>
          <Modal close={this.closeModal}
            title={t('tensorAnalytics.common.delete')}
            style={{
              width: '60%',
            }}
          >
            {deleteChildren}
          </Modal>
        </div>
        {createModalShow ? createJobModal : null}
        <div className={updateModalShow ? 'show' : 'hide'}>
          {updateJobModal}
        </div>
        <div className={inProgressModalShow ? 'show' : 'hide'}>
          <Modal close={this.closeModal}
            title={t('tensorAnalytics.common.caution')}
            style={{
              width: '50%',
            }}
          >
            {inProgressWarning}
          </Modal>
        </div>
        <div className={getStartedModalShow ? 'show' : 'hide'}>
          {splashModal}
        </div>
      </div>
    );
  }
}

export default connect(state => state)(Schedules);
